// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Clock from "@insite/mobius/Icons/Clock";
import { searchHistoryStyles } from "@steiner/Overrides/Widgets/Header/SearchHistory";
import { styledScrollbar, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

searchHistoryStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        padding: 12px;
        width: 100%;

        max-height: calc(100vh - 62px);
        overflow: auto;
        ${styledScrollbar(4)}

        ${xScreen("lte", "md")} {
            max-height: calc(100vh - 168px);
        }
    `,
};

searchHistoryStyles.headerText = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

searchHistoryStyles.clearLink = {
    typographyProps: {
        size: "12px",
        lineHeight: "15px",
    },
};

searchHistoryStyles.topWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `,
};

searchHistoryStyles.icon = {
    src: Clock,
    size: 12,
    color: "primary",
    css: css`
        margin-right: 6px;
    `,
};

searchHistoryStyles.link = {
    typographyProps: {
        size: "12px",
        lineHeight: "15px",
    },
};

searchHistoryStyles.itemsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
    `,
};
